import { User } from "oidc-client-ts";
import { useContext, useEffect } from "react";
import { resourceCache, useAsyncResource } from "use-async-resource";
import { AuthContext } from "../contexts/AuthContext";

export default function useUser(): User | undefined {
  const { manager, getUser } = useContext(AuthContext);
  const [idpUserReader, reload] = useAsyncResource(getUser, []);

  // Subscribe to changes in user
  useEffect(() => {
    function userLoaded() {
      resourceCache(getUser).clear();
      reload();
    }
    manager.events.addUserLoaded(userLoaded);

    return () => {
      manager.events.removeUserLoaded(userLoaded);
    };
  }, [reload, manager, getUser]);
  return idpUserReader() || undefined;
}
